import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import DataApi from 'api/faber/DataApi'
import OneTimePackApi from 'api/faber/OneTimePackApi'
import ColorBox from 'common/Box/ColorWhiteBox'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'
import OrbitSession from 'hooks/useCookies'
import {
  EmailSentLogsV2,
  NewEsimReplacement,
  SmartDelayFormLogsV2
} from 'pages/Customers/sharedComponents'
import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'
import {
  GetAllFaberUsersDetails,
  GetAllInactiveAndTerminatedOtpackUserPlansDetailsType
} from 'types/api/faber/oneTimePack.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

import CDRLogsV3 from './CDRLogsV3'
import TerminatedPlanHistory from './TerminatedPlanHistory'

export default function ExternalEventLogsPage({ customerRow }: EventLogsProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false)

  /*FOR WINBACK LOGS DATA GRID */
  // const winbackColumns = generateColumnHeader(WINBACK_LOG)
  // const [filterActive, setFilterActive] = useState<boolean>(false)
  // const [filteredRows, setFilteredRows] = useState<winbackPlansType[]>([])
  // const [winbackFilterFieldsChecked, setWinbackFilterFieldsChecked] = useState<
  //   string[]
  // >([])
  // const [winbackRows, setWinbackRows] = useState<WinbackType[]>([])
  // const [waiverRows, setWaiverRows] = useState<BillWaiverAuditLogType[]>([])
  // const [voucherRows, setVoucherRows] = useState<VoucherAuditLogType[]>([])
  const [customerData, setCustomerData] = useState<SubscriptionsTableRows>(
    {} as SubscriptionsTableRows
  )

  // FOR ACCORDION
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false)
    }

  const faberToken = OrbitSession.get('faberToken')

  const location = useLocation()
  const customerInfo = location.state as GetAllFaberUsersDetails

  //FOR DATA GRID
  // const [rows, setRows] = useState<CustomerDetailsLogType[]>([])
  // const [page, setPage] = useState(0)

  //eSIM STATUS API (gets ICCID)
  const [iccid, setIccid] = useState('')

  const { refetch: refetchEsimStatus } = useQuery(
    ['get-esim-status', customerRow.userID],
    async () => {
      const { data } = await DataApi.getExternalEsimStatus(
        faberToken,
        customerRow.userID
      )
      return data
    },
    {
      onSuccess: (res) => {
        setIccid(res.data.iccid)
        return res.data
      }
    }
  )

  // const {
  //   data: voucherLogs,
  //   refetch: refetchVoucherData,
  //   isLoading: isVoucherWaiverLogsLoading
  // } = useQuery(
  //   ['getCustomerVouchers', customerRow.userID],
  //   async () => {
  //     // TODO : Check if this is needed, because there seems to be no calls to this
  //     // so there may not be a need for this to be here in the first place
  //     const winbackVoucherLogs = await CustomerLogApi.getVoucherLogs(
  //       customerRow.userID,
  //       faberToken
  //     )
  //     return winbackVoucherLogs
  //   },
  //   {
  //     onError: () => {
  //       setVoucherRows([])
  //     },
  //     onSuccess: (res) => {
  //       if (res.data.data) {
  //         setVoucherRows(res.data.data)
  //       } else {
  //         setVoucherRows([])
  //       }
  //     },
  //     enabled: !!customerInfo.subscription && expanded === 'panel2'
  //   }
  // )

  //TERMINATED USER PLAN API
  const [terminatedUserPlan, setTerminatedUserPlan] = useState<
    GetAllInactiveAndTerminatedOtpackUserPlansDetailsType[]
  >([])
  const {
    refetch: refetchTerminatedUserPlans,
    isLoading: isTerminatedUserPlansLoading
  } = useQuery(
    // the externaleventslogs page uses customerInfo.user_id as compared
    // to customerInfo._id, which is used at EventLogsPage
    ['getAllInactiveAndTerminatedOtpackUserPlans', customerInfo.user_id],
    async () => {
      // External user needs to go through the external auth middleware
      return OneTimePackApi.getExternalAllTerminatedOtpackUserPlans(
        customerInfo.user_id,
        faberToken
      )
    },
    {
      onSuccess: (res) => {
        setTerminatedUserPlan(res.data.body.data)
      },
      onError: () => {
        return []
      },
      enabled: customerInfo.otpack && expanded === 'panel3'
    }
  )

  //WAIVER LOGS API
  // const {
  //   data: waiverLogs,
  //   refetch: refetchWaiverData,
  //   isLoading: isBillWaiverLogsLoading
  // } = useQuery(
  //   ['getCustomersWaivers', customerRow.userID],
  //   async () => {
  //     // external events page use external endpoint
  //     const winbackWaiverLogs = await CustomerLogApi.getExternalWaiverLogs(
  //       customerRow.userID,
  //       faberToken
  //     )

  //     return winbackWaiverLogs
  //   },
  //   {
  //     onError: () => {
  //       setWaiverRows([])
  //     },
  //     onSuccess: (res) => {
  //       if (res.data.data) {
  //         setWaiverRows(res.data.data)
  //       } else {
  //         setWaiverRows([])
  //       }
  //     },
  //     enabled: !!customerInfo.subscription && expanded === 'panel2'
  //   }
  // )

  // const filterFields = useMemo(() => {
  //   const winbackFilterFields: IFilterField[] = [
  //     {
  //       values: getWinbackFilterOptions(
  //         winbackRows.map((row) => row.updateStatus),
  //         ['VOUCHER', 'WAIVER']
  //       ),
  //       checked: winbackFilterFieldsChecked,
  //       setChecked: setWinbackFilterFieldsChecked,
  //       name: 'Winback',
  //       index: 'Winback'
  //     }
  //   ]
  //   return winbackFilterFields
  // }, [voucherRows, waiverRows, winbackFilterFieldsChecked, filteredRows])

  // ACCOUNT AND PLAN STATUS API
  // const {
  //   data: dataLog,
  //   refetch: refetchCustomerLogs,
  //   isLoading: isStatusUpdateLogsLoading
  // } = useQuery(
  //   ['getUpdateLog', customerRow.userID],
  //   async () => {
  //     // external event logs use external endpoint
  //     const customerLogsResponse = await CustomerLogApi.getExternalCustomerLogs(
  //       customerRow.userID,
  //       faberToken
  //     )
  //     return customerLogsResponse.data
  //   },
  //   {
  //     enabled: !!customerInfo.subscription && expanded === 'panel3'
  //   }
  // )

  //Sub PLans history
  // it wont be a subscription
  // useEffect(() => {
  //   if (customerInfo.subscription) {
  //     if (dataLog && dataLog.data?.length > 0) {
  //       setRows(dataLog.data)
  //     } else {
  //       setRows([])
  //     }
  //   }
  // }, [dataLog, customerInfo])

  //WINBACK
  // useEffect(() => {
  //   if (customerInfo.subscription) {
  //     if (waiverLogs && voucherLogs) {
  //       setWinbackRows([...voucherRows, ...waiverRows])
  //     }
  //     if (voucherLogs) {
  //       setWinbackRows([...voucherRows])
  //     }
  //   }
  // }, [voucherRows, waiverRows, customerInfo])
  // }, [voucherRows, customerInfo])

  useEffect(() => {
    refetchEsimStatus()
  }, [customerRow])

  useEffect(() => {
    // if (customerInfo.subscription) {
    //   refetchVoucherData()
    //   refetchWaiverData()
    //   refetchCustomerLogs()
    // } else if (customerInfo.otpack) {
    //   refetchTerminatedUserPlans()
    // }
    if (customerInfo.otpack) {
      refetchTerminatedUserPlans()
    }
  }, [customerInfo])

  useEffect(() => {
    if (customerRow) {
      const transformedCustomerRow = {
        firstName: customerRow.firstName || '',
        lastName: customerRow.lastName || '',
        user_metadata: customerRow.user_metadata || { email: '' },
        userID: customerRow.userID || '',
        userEmail: customerRow.userEmail || '',
        email: customerRow.email || '',
        iccid: '',
        planStatus: customerRow.planStatus || '',
        planName: customerRow.planName || '',
        subscriptionStartAt: '',
        msisdn: customerRow.msisdn || '',
        cycleCount: 0,
        countryCode: customerRow.countryCode || ''
      }
      setCustomerData(transformedCustomerRow)
    }
  }, [customerRow])

  return (
    <>
      <ColorBox sx={{ mt: 2 }}>
        <Accordion
          elevation={0}
          defaultExpanded={false}
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextColorFontHeader>eSIM Replacement Logs</TextColorFontHeader>
          </AccordionSummary>
          <AccordionDetails>
            <NewEsimReplacement
              customerRow={customerInfo}
              faberToken={faberToken}
              expanded={expanded}
              isExternal={true}
            />
          </AccordionDetails>
        </Accordion>
      </ColorBox>
      <ColorBox sx={{ mt: 2 }}>
        <Accordion
          elevation={0}
          defaultExpanded={false}
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextColorFontHeader>All Customer Email Logs</TextColorFontHeader>
          </AccordionSummary>
          <AccordionDetails>
            <EmailSentLogsV2 
              customerRow={customerInfo}
              expanded={expanded}
              isExternal={true}
               />
          </AccordionDetails>
        </Accordion>
      </ColorBox>
      <ColorBox sx={{ mt: 2 }}>
        <Accordion
          elevation={0}
          defaultExpanded
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextColorFontHeader>CDR Logs</TextColorFontHeader>
          </AccordionSummary>
          <AccordionDetails>
            <CDRLogsV3
              faberToken={faberToken}
              customerRow={customerRow}
              iccid={iccid}
              expanded={expanded}
              isExternal={true}
            />
          </AccordionDetails>
        </Accordion>
      </ColorBox>

      <ColorBox sx={{ mt: 2 }}>
        <Accordion
          elevation={0}
          defaultExpanded
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextColorFontHeader>Packs History</TextColorFontHeader>
          </AccordionSummary>

          {isTerminatedUserPlansLoading ? (
            <CircularProgress />
          ) : (
            <TerminatedPlanHistory terminatedUserPlan={terminatedUserPlan} />
          )}

          {/* {customerInfo.otpack ? (
            isTerminatedUserPlansLoading ? (
              <CircularProgress />
            ) : (
              <TerminatedPlanHistory terminatedUserPlan={terminatedUserPlan} />
            )
          ) : (
            <AccordionDetails>
              <AbstractAuditLogDataGrid
                loading={isStatusUpdateLogsLoading}
                getRowId={(row) => rows.indexOf(row)}
                rows={rows}
                columns={acctStatusColumns}
                pagination
                page={page}
                onPageChange={(newPage) => setPage(newPage)}
                pageSize={5}
                tableHeight='350px'
                rowHeight={50}
              />
            </AccordionDetails>
          )} */}
        </Accordion>
      </ColorBox>

      <ColorBox sx={{ mt: 2 }}>
        <Accordion
          elevation={0}
          defaultExpanded={false}
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <TextColorFontHeader>Smart Delay Forms</TextColorFontHeader>
          </AccordionSummary>
          <AccordionDetails>
            {customerData && (
              <SmartDelayFormLogsV2
                faberToken={faberToken}
                customerRow={customerData}
                expanded={expanded}
                isExternal={true}
              />
            )}
          </AccordionDetails>
        </Accordion>
      </ColorBox>
    </>
  )
}
interface EventLogsProps {
  customerRow: TransformedFaberUserData
}

// type WinbackType = BillWaiverAuditLogType | VoucherAuditLogType
